<template lang="pug">
 v-list-group(prepend-icon="mdi-clock-outline").app-list-child
  template(v-slot:activator)
    v-list-item-title  {{ title }}

  v-list-item(v-for="location in courseLocationsWithAdditionalInfo" :key="location.ID" link
    @click="go(location.ID)"
    :class="{'v-list-item--active': $route.query.city === location.ID && selectedPage}"
  ).app-list-child__item
    v-list-item-content.flex
      div
        span {{ location.name }}
        span(v-if="!isCursussen") ({{ location.top_cbr_queue_count }})
</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex"

export default {
  props: {
    isCursussen: {
      type: Boolean,
      default: false,
    },
    nameToGo: {
      type: String
    },
    title: {
      type: String,
      default: 'List management'
    }
  },
  computed: {
    ...mapGetters({
      courseLocationsWithAdditionalInfo: 'crmCourseCities/itemsWithAdditionalInfo'
    }),
    selectedPage() {
      return this.$route.name === this.nameToGo
    }
  },
  created() {
  },
  methods: {
    async go(location) {
      await this.$router.push({name: this.nameToGo, query: { city: location, page: 1 }});
      this.updateItems();
    },
    updateItems() {
      this.$store.dispatch('crmCourseCities/listWithAdditionalInfo')
    }
  }
}
</script>

<style lang="scss" scoped>
  .flex{

    span:first-of-type{
      margin-right: 5px;
    }
  }
</style>